import React from 'react';
import { style } from 'typestyle';
import { OneContentIcon } from '../../Icons/MobileContentSize/One';
import { TwoContentIcon } from '../../Icons/MobileContentSize/Two';
import { ThreeContentIcon } from '../../Icons/MobileContentSize/Three';
import { ADALONG_COLORS } from '@src/styles';
import { MOBILE_CAROUSEL_CONTENT_SIZE_DEFAULT } from '../utils/variables';

interface Props {
  value?: number;
  onChange: (value: number) => any;
}

export function MobileContentSizeSelector({ value = MOBILE_CAROUSEL_CONTENT_SIZE_DEFAULT, ...props }: Props) {
  const onChange = (selectedValue: number) => {
    props.onChange(selectedValue);
  };

  return (
    <div className={containerStyle}>
      {[
        { value: 1, Icon: OneContentIcon },
        { value: 2, Icon: TwoContentIcon },
        { value: 3, Icon: ThreeContentIcon },
      ].map(({ value: itemValue, Icon }) => (
        <div key={itemValue} className={iconContainerClass}>
          <Icon 
            onClick={() => onChange(itemValue)} 
            selected={value === itemValue}
            width={60}
            height={60}
          />
          <div className={legendClass(value === itemValue)}>
            {itemValue}
          </div>
        </div>
      ))}
    </div>
  );
}

const containerStyle = style({
  display: 'flex',
  justifyContent: 'space-between',
  width: '200px',
});

const iconContainerClass = style({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 20,
});

const legendClass = (isSelected: boolean) => style({
  marginTop: '5px',
  fontSize: '14px',
  color: isSelected ? ADALONG_COLORS.FLASH_BLUE : undefined,
});
